// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"eb4d437c","68":"2752f6a6","125":"67fd1e2a","232":"4152a6a3","914":"a9b2ad6e"}[chunkId] + ".chunk.js";
};